<template>
  <div class="user-info-small-card" :class="[`is-${gender}`]">
    <div class="user-info-small-card__picture"
      :class="{ 'is-reactive': reactive }">
      <el-tooltip popper-class="user-info" effect="dark" placement="bottom-start" :open-delay="500">
        <nuttrema-iconica-sidebar-link
           class="no-hover"
           size="picture"
          :noHover="true"
          :icon="`icon-ca-user-${gender}`"
          :theme="gender"
          :picture="picture">
        </nuttrema-iconica-sidebar-link>
        <template slot="content">
          <a @click="gotoProfile">{{ $t('label.goto_profile') }}</a>
        </template>
      </el-tooltip>
    </div>
    <div class="user-info-small-card__text">
      <div v-if="supTitle" class="user-info-small-card__text__sup-title" :class="{ 'is-reactive': reactive }">
        {{ supTitle }}
      </div>
      <div class="user-info-small-card__text__name">
        {{ _get(personDetails, 'full_name') }}
      </div>
      <div v-if="!supTitle" class="user-info-small-card__text__info" :class="{ 'is-reactive': reactive }">
        {{ $t('label.person_info', { gender: $t(`label.${gender}`), age: _get(personDetails, 'age', 0) }) }}
      </div>
    </div>
  </div>
</template>

<script>
import { get, has } from 'lodash';

import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'user-info-small-card',
  props: {
    reactive: {
      type: Boolean,
      required: false,
      default: true,
    },
    personDetails: {
      type: Object,
      required: true,
      default: null,
    },
    supTitle: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaIconicaSidebarLink,
  },
  computed: {
    picture() {
      const imagesRoot = process.env.IMAGES_ROOT;
      const path = get(this.personDetails, 'ProfilePicture.path', null);
      const filename = get(this.personDetails, 'ProfilePicture.thumbnails.large.filename', null);

      return has(this.personDetails, 'ProfilePicture', false) ? `${imagesRoot}${path}${filename}` : '';
    },
    gender() {
      return get(this.personDetails, 'gender', null) || 'genderless';
    },
    icon() {
      const gender = get(this.personDetails, 'gender', null);
      return gender ? `icon-ca-user-${gender}` : 'far fa-genderless';
    },
  },
  methods: {
    gotoProfile() {
      this.$router.push({ name: 'participant-profile', params: { id: get(this.personDetails, 'id') } });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  @import "~styles/theme/person-colors";
  .user-info-small-card {
    display: flex;
    align-items: center;
    .user-info-small-card__picture {
      margin-right: 0.5em;
      /deep/ .iconica-sidebar-link:hover {
        cursor: pointer;
      }
    }
    .user-info-small-card__text {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .user-info-small-card__text__name {
        line-height: 1.15;
      }
      .user-info-small-card__text__info {
        font-size: 0.85rem;
        line-height: 1;
        color: $gray-light;
      }
      .user-info-small-card__text__sup-title {
        font-size: 0.75rem;
        line-height: 1;
        color: $gray-light;
        text-transform: uppercase;
      }
    }
    .is-expanded & {
      .user-info-small-card__picture.is-reactive,
      .user-info-small-card__text__info.is-reactive,
      .user-info-small-card__text__sup-title.is-reactive {
        display: none;
      }
      .user-info-small-card__text__name.is-reactive {
        font-weight: 500;
      }
    }
    &.is-in-section {
      padding: 0.5em 0.75em 0.5em;
      background-color: #fff;
      .user-info-small-card__text__name {
        font-weight: 500;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/card/user-info-small-card.vue